import React from "react";
import { useReveal } from "@/hooks/useReveal";
import { trackEvent } from "@/lib/analytics";

const Apple = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
    <path d="M16.365 1.43c0 1.14-.42 2.22-1.18 3.02-.78.84-2.05 1.47-3.06 1.4-.13-1.1.42-2.27 1.13-3.02.78-.84 2.13-1.46 3.11-1.4zM21 17.27c-.55 1.27-.81 1.84-1.52 2.96-.99 1.57-2.38 3.52-4.1 3.54-1.53.02-1.93-.99-4.01-.98-2.08.01-2.52.99-4.05.98-1.72-.02-3.05-1.79-4.03-3.36-2.75-4.36-3.04-9.48-1.34-12.2 1.2-1.92 3.1-3.04 4.88-3.04 1.82 0 2.96 1 4.47.99 1.47 0 2.36-.99 4.47-.99 1.6 0 3.29.87 4.5 2.37-3.95 2.16-3.3 7.81 1.73 9.73z" />
  </svg>
);

const Play = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
    <path d="M3.6 2.3c-.4.4-.6 1-.6 1.7v16c0 .7.2 1.3.6 1.7l9.1-9.7L3.6 2.3zm12.1 11.4 2.6 1.5 2.3-1.3c.9-.5.9-1.8 0-2.3l-2.3-1.3-2.6 1.5-1.7 1 1.7.9zm-1.7-2 1.7-1L4.6 1.6c-.2-.1-.4-.1-.5 0l10.2 10.3-.3.4 1 .6zm0 4 1-.6-1-.6L4.1 22.3c.2.1.4.1.5 0l11-6.6-1.6-1z" />
  </svg>
);

export default function AppDownload() {
  const ref = useReveal();

  return (
    <section
      id="app"
      ref={ref}
      className="relative py-32 sm:py-44 lg:py-52 bg-[var(--luft-bg)]"
      data-testid="app-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-y-16 lg:gap-x-14 items-start">
          <div className="col-span-12 lg:col-span-6 reveal">
            <p className="eyebrow mb-10">09 — A App</p>
            <h2 className="editorial-heading text-[clamp(2.2rem,5.4vw,4.4rem)] text-[var(--luft-ink)] max-w-2xl">
              A sua aula,<br />
              <em className="editorial-italic">à mão</em>.
              <span
                className="inline-block ml-3 align-middle w-2.5 h-2.5 rounded-full"
                style={{ backgroundColor: "var(--luft-yellow)" }}
                aria-hidden="true"
              />
            </h2>
            <p className="mt-10 max-w-md text-[var(--luft-ink-soft)] font-body font-light text-base leading-relaxed">
              Reserva as tuas aulas diretamente na app{" "}
              <span className="italic font-display text-lg text-[var(--luft-ink)]">
                Lu.ft Pilates Studio
              </span>
              . Disponível em iOS e Android.
            </p>

            <div className="mt-14 flex flex-col sm:flex-row gap-4">
              <a
                href="https://apps.apple.com/pt/app/luft-pilates-studio/id6761007459"
                target="_blank"
                rel="noopener noreferrer"
                className="store-pill"
                data-testid="app-store-btn"
                onClick={() =>
                  trackEvent("app_store_click", {
                    surface: "desktop",
                    location: "app_section",
                    store: "app_store",
                  })
                }
              >
                <Apple />
                <span className="flex flex-col items-start">
                  <span className="label">Download on the</span>
                  <span className="sublabel">App Store</span>
                </span>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=pt.yogobooking.luftpilates&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="store-pill"
                data-testid="google-play-btn"
                onClick={() =>
                  trackEvent("google_play_click", {
                    surface: "desktop",
                    location: "app_section",
                    store: "google_play",
                  })
                }
              >
                <Play />
                <span className="flex flex-col items-start">
                  <span className="label">Get it on</span>
                  <span className="sublabel">Google Play</span>
                </span>
              </a>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-6 lg:pl-10 reveal">
            <div className="border-l border-[var(--luft-line)] pl-8 sm:pl-12 py-4">
              <p className="font-display italic text-[var(--luft-ink-soft)] text-2xl sm:text-3xl leading-snug">
                "Reservar, cancelar, mudar de aula —<br />
                em três toques, com toda a calma."
              </p>
            </div>

            <div className="mt-16 grid grid-cols-3 gap-6">
              {[
                { k: "iOS", v: "App Store" },
                { k: "Android", v: "Google Play" },
                { k: "Web", v: "em breve" },
              ].map((it) => (
                <div key={it.k} className="border-t border-[var(--luft-line)] pt-5">
                  <p className="font-display text-2xl text-[var(--luft-ink)]">{it.k}</p>
                  <p className="eyebrow mt-3">{it.v}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
